export enum DPSitePage {
  JobInitial = 1,
  JobComplete = 2,
}
